import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { moment, microAppUtil } from '@platform/api';
import { getMultiLang, serverTimeToLocal, withViewModel, formatDatetime, formatNumber } from '@platform/api';
import { getScrollTop } from './methods';
import optimizedResize from './optimizedResize';

// 初始化resize事件
const OptimizedResizeEventName = 'optimizedResizeTransferList';
optimizedResize(OptimizedResizeEventName);

const defaultColor = new Set(['#111111', '#555555', '#111', '#555']);


@withViewModel
export class CreateTranferList extends Component {
    constructor(props) {
        super(props);
        this.ViewModel = this.props.ViewModel;
        this.expandArrId = this.props.events && this.props.events.expandArr;
        this.state = {
            switchViewState: 'evenUp',
            transferList: null,
            transformForm: null,
            top: 0,
            json: {},
            LangData: null,
            height: 0,
        };
        this.props._this.myState.transferListComponent = this;
        this.appBody = microAppUtil.getDocument();
    }

    _viewModelGetData = dataSource => {
        return this.ViewModel.getData(dataSource, this.props._runContext);
    };

    componentWillMount() {
        let callback = (json, bool, LangData) => {
            let { _this, dataSource, componentInitFinished } = this.props;
            this.setState({
                json,
                LangData,
            });
            if (dataSource) {
                let data = this._viewModelGetData(dataSource);
                // let data = { transferTable: {} };
                // console.log("获取缓存pk数据", dataPk);
                if (data && data.transferTable) {
                    _this.setState({ transferTable: data.transferTable }, () => {
                        //执行数据初始化周期函数
                        if (typeof componentInitFinished == 'function') {
                            componentInitFinished();
                        }
                    });
                }
            }
        };
        getMultiLang({ moduleId: 'page-transferTable', callback });
    }

    handleOptimizedResize = () => {
        this.onresizeEvent();
    }

    componentDidMount() {
        if (this.props.layout === 'flex') {
            return;
        }
        let $left = ReactDOM.findDOMNode(this);
        let selector = $left && $left.querySelector('.transfer-list-main-wrapper');
        let $right = $left && $left.nextElementSibling;
        let width = selector ? (selector.offsetWidth - 2) : 0;
        $right && ($right.style.marginLeft = width + 'px');

        this.onresizeEvent();
        window.addEventListener(OptimizedResizeEventName, this.handleOptimizedResize);
        microAppUtil.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    componentWillUnmount() {
        window.removeEventListener(OptimizedResizeEventName, this.handleOptimizedResize);
        microAppUtil.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    //YBP-SSCT-BUG-9 YBP-CCF-BUG-2755
    handleVisibilityChange = data => {
        if (data.visibilityState === 'visible') {
            if (this.props.layout === "flex") {
                return;
            }
            let $left = ReactDOM.findDOMNode(this);
            let selector =
              $left && $left.querySelector(".transfer-list-main-wrapper");
            let $right = $left && $left.nextElementSibling;
            let width = selector ? selector.offsetWidth - 2 : 0;
            $right && ($right.style.marginLeft = width + "px");
        }
    }

    componentWillReceiveProps(nextProps) {
        // 更新高度
        this.setState({ resize: new Date().getTime() }, () => {
            if (this.props.layout === 'flex') {
                return;
            }
            // console.log("渲染次数", nextProps);
            this.onresizeEvent();
        });
    }

    componentDidUpdate() {
        if (this.props.layout === 'flex') {
            return;
        }
        let $left = ReactDOM.findDOMNode(this);
        let selector = $left && $left.querySelector('.transfer-list-main-wrapper');
        let $right = $left && $left.nextElementSibling;
        let width = selector ? (selector.offsetWidth - 2) : 0;
        $right && ($right.style.marginLeft = width + 'px');
    }

    /*
    * 下游转单卡片自适应
    * */
    onresizeEvent = () => {
        if (this.props.layout === 'flex') {
            return;
        }
        let selector = this.appBody.querySelector('.transfer-list-main-wrapper');
        if (selector) {
            this.setState({
                top: selector.offsetTop,
                height: getScrollTop(this.appBody) - selector.offsetTop,
            });
        }

    }

    /*
    * 卡片渲染
    *
    * */
    getTransferListDom = () => {
        let {
            _this,
            dataAreaCode,
            handleTransformListClick,
            transformForm, //下游转单的数据集合
            transferListId,
            // transformListMeta,
            layout,
        } = this.props;
        if (!_this.state.meta) {
            return false;
        }
        if (!_this.state.meta[transferListId] || !_this.myState.transferList[transferListId]) {
            return false;
        }
        //转单模板信息
        let transformListMeta = _this.state.meta[transferListId].items;

        let { height, json, LangData } = this.state;
        let flag = transformForm.show && transformForm.list && transformForm.list.length > 1;
        // position: 'fixed', top: '42px', left: '0px', bottom: '16px'

        const listWrapper = layout !== 'flex' ? { height: height - 8, overflow: 'hidden' } : {};
        const listMain = layout !== 'flex' ? { height: height - 8, overflow: 'auto' } : {};

        return (
            <div
                className={`transfer-list-main-wrapper ${flag ? 'show-tranferList' : 'hide-tranferList'} `}
                style={listWrapper}
            >
                {
                    flag ? (
                        <div
                            className="transformtable-main"
                            style={listMain}
                        >
                            <div className="transform-list">
                                <ul className='transform-list-content' >
                                    {transformForm.list && transformForm.list.map((item, index) => {
                                        return (<li
                                            key={index}
                                            className={`${index === transformForm.activeIndex ? 'item active-transfer-list-item' : 'item'} ${item.complete && 'complete'}`}
                                            onClick={() => {
                                                handleTransformListClick.call(this, item.data, index);
                                                _this.myState.stopSetScroll = false;
                                            }}
                                        >

                                            <span className={`status${item.complete ? ' complete' : ''}`} />
                                            <div className="content">
                                                {
                                                    transformListMeta.map((val, index) => {
                                                        let itemVal = item.data.head[dataAreaCode].rows[0].values[val.attrcode] || {
                                                            value: '',
                                                            display: '',
                                                        };
                                                        // 避免影响原始数据
                                                        itemVal = { ...itemVal };
                                                        // 处理一下数据为空的情况
                                                        itemVal.display = itemVal.display || '';
                                                        itemVal.value = itemVal.value || '';

                                                        let labelStyle = defaultColor.has(val.color) ? {} : { color: val.color };
                                                        let contentStyle = val.contentcolor ? { color: val.contentcolor } : {};

                                                        if (val.itemtype !== 'datepicker' && val.itemtype !== 'datetimepicker') {
                                                            let finalVal = itemVal && (itemVal.display || itemVal.value || '') || '';
                                                            if (val.itemtype === 'number') { finalVal = formatNumber(finalVal); }
                                                            return (
                                                                val.visible && (
                                                                    <div className="item-inner">
                                                                        <span className='item-inner-label' style={labelStyle}>
                                                                            {`${val.label}：`}
                                                                        </span>
                                                                        <span
                                                                            className='item-inner-content'
                                                                            style={{ paddingLeft: 8, ...contentStyle }}
                                                                        >
                                                                            {finalVal}
                                                                        </span>
                                                                    </div>
                                                                ));
                                                        } else {

                                                            let format = val.itemtype === 'datepicker' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';
                                                            let dateFlag = val.itemtype === 'datepicker' ? 'date' : 'datetime';
                                                            let finalValue = '';
                                                            if (itemVal && (itemVal.display || itemVal.value)) {
                                                                finalValue = formatDatetime(serverTimeToLocal(moment(itemVal.display || itemVal.value), val.isconverttimezones).format(format), dateFlag);
                                                            }
                                                            return (
                                                                val.visible && (
                                                                    <div className="item-inner">
                                                                        <span className='item-inner-label' style={labelStyle}>
                                                                            {`${val.label}：`}
                                                                        </span>
                                                                        <span
                                                                            className='item-inner-content'
                                                                            style={{ paddingLeft: 8, ...contentStyle }}
                                                                        >{finalValue}</span>
                                                                    </div>
                                                                )
                                                            );
                                                        }
                                                    })
                                                }
                                            </div>
                                            {item.complete && <span className="saved-mark">{json["page-transferTable-0016"] || "已处理"}</span>}
                                        </li>
                                        );
                                    })}
                                </ul>

                            </div>
                        </div>
                    ) : ''
                }

                {flag && transformForm.list[0] ? (
                    <div
                        className="total-area"
                        style={{ bottom: '0' }}
                    >{json['page-transferTable-0014'] || '共计-1'}：<span className="active">{LangData ? LangData.get('page-transferTable-0012', { n: transformForm.list.length }) : transformForm.list.length + '条'}</span>
                    </div>
                ) : ''}
            </div>
        );
    }

    render() {
        let {
            transformForm, //下游转单的数据集合
            layout,
        } = this.props;

        let flag = transformForm.show && transformForm.list && transformForm.list.length > 1;

        return <span className={`transfer-list-left ${flag ? 'show-transfer-list-only' : 'hide-transfer-list-only'}  ${layout === 'flex' ? 'transfer-list-flex' : ''}`}>{this.getTransferListDom()}</span>;
    }
}



@withViewModel
export class TranferListForLowCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            LangData: null,
        };
        this.props._this.myState.transferListComponent = this;
    }

    _viewModelGetData = dataSource => {
        return this.props.ViewModel.getData(dataSource, this.props._runContext);
    };

    componentWillMount() {
        let callback = (json, bool, LangData) => {
            let { _this, dataSource, componentInitFinished } = this.props;
            this.setState({
                json,
                LangData,
            });
            if (dataSource) {
                let data = this._viewModelGetData(dataSource);
                // let data = { transferTable: {} };
                // console.log("获取缓存pk数据", dataPk);
                if (data && data.transferTable) {
                    _this.setState({ transferTable: data.transferTable }, () => {
                        //执行数据初始化周期函数
                        if (typeof componentInitFinished == 'function') {
                            componentInitFinished();
                        }
                    });
                }
            }
        };
        getMultiLang({ moduleId: 'page-transferTable', callback });
    }


    /*
    * 卡片渲染
    *
    * */
    getTransferListDom = (flag) => {
        let {
            _this,
            dataAreaCode,
            handleTransformListClick,
            transformForm, //下游转单的数据集合
            transferListId,
            // transformListMeta,
        } = this.props;
        if (!_this.state.meta) {
            return false;
        }
        if (!_this.state.meta[transferListId] || !_this.myState.transferList[transferListId]) {
            return false;
        }
        //转单模板信息
        let transformListMeta = _this.state.meta[transferListId].items;

        let { json, LangData } = this.state;
        return (
            <div
                className={`transfer-main ${flag ? ' show-tranferList' : ' hide-tranferList'} `}
            >
                {
                    flag ? (
                        <div className='transfer-list-wrapper'>
                            <ul>
                                {transformForm.list && transformForm.list.map((item, index) => {
                                    return (<li
                                        key={index}
                                        className={`${index === transformForm.activeIndex ? 'item active-transfer-list-item' : 'item'} ${item.complete ? ' complete' : ''}`}
                                        onClick={() => {
                                            handleTransformListClick.call(this, item.data, index);
                                            _this.myState.stopSetScroll = false;
                                        }}
                                    >
                                        <span className={`status${item.complete ? ' complete' : ''}`} />
                                        <div className="content">
                                            {
                                                transformListMeta.map((val, index) => {
                                                    let itemVal = item.data.head[dataAreaCode].rows[0].values[val.attrcode] || {
                                                        value: '',
                                                        display: '',
                                                    };
                                                    // 避免影响原始数据
                                                    itemVal = { ...itemVal };
                                                    // 处理一下数据为空的情况
                                                    itemVal.display = itemVal.display || '';
                                                    itemVal.value = itemVal.value || '';
                                                    if (val.itemtype !== 'datepicker' && val.itemtype !== 'datetimepicker') {
                                                        let finalVal = itemVal && (itemVal.display || itemVal.value || '') || '';
                                                        if (val.itemtype === 'number') { finalVal = formatNumber(finalVal); }
                                                        return (
                                                            val.visible && (
                                                                <div className="item-inner">
                                                                    {`${val.label}：`}
                                                                    <span style={{ paddingLeft: 8 }}>
                                                                        {finalVal}
                                                                    </span>
                                                                </div>
                                                            ));
                                                    } else {

                                                        let format = val.itemtype === 'datepicker' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';
                                                        let dateFlag = val.itemtype === 'datepicker' ? 'date' : 'datetime';
                                                        let finalValue = '';
                                                        if (itemVal && (itemVal.display || itemVal.value)) {
                                                            finalValue = formatDatetime(serverTimeToLocal(moment(itemVal.display || itemVal.value), val.isconverttimezones).format(format), dateFlag);
                                                        }
                                                        return (
                                                            val.visible && (
                                                                <div className="item-inner">
                                                                    {`${val.label}：`}
                                                                    <span
                                                                        style={{ paddingLeft: 8 }}
                                                                    >{finalValue}</span>
                                                                </div>
                                                            )
                                                        );
                                                    }
                                                })
                                            }
                                        </div>
                                        {item.complete && <span className="saved-mark">{json["page-transferTable-0016"] || "已处理"}</span>}
                                    </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ) : ''
                }

                {flag && transformForm.list[0] ? (
                    <div
                        className="total-bottom"
                    >{json['page-transferTable-0014'] || '共计-1'}：<span className="active">{LangData ? LangData.get('page-transferTable-0012', { n: transformForm.list.length }) : transformForm.list.length + '条'}</span>
                    </div>
                ) : ''}
            </div>
        );
    }

    render() {
        let {
            transformForm, //下游转单的数据集合
        } = this.props;

        let flag = transformForm.show && transformForm.list && transformForm.list.length > 1;

        return this.getTransferListDom(flag);
    }
}
